var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _ellipse, _ellipse2, _ellipse3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _defs, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#a98a58"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#b3986c",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#6b4a2e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96L60 124",
    stroke: "#553b24",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92C38 84 50 84 58 94L60 100L62 94C70 84 82 84 84 92C86 102 74 108 60 106C46 108 34 102 36 92Z",
    fill: "#efe3c8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 94Q44 98 48 94M50 98Q54 102 58 98M62 98Q66 102 70 98M72 94Q76 98 80 94",
    stroke: "#cdbd9a",
    strokeWidth: 1.6,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 104H40M80 104H94",
    stroke: "#553b24",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d8b99d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f6d3b3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 61,
    r: 0.9,
    fill: "#9f8974"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 62.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 63.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 61,
    r: 0.9,
    fill: "#9f8974"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 62.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 63.5,
    r: 0.9,
    fill: "#9f8974"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bfa48b",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55Q51 50 55 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55Q69 50 73 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#6b4a2e",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#6b4a2e",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67Q60 78 69 67Z",
    fill: "#fff",
    stroke: "#2a1d1a",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50C35 29 48 22 60 22S85 29 82 50C78 41 71 35 60 35S42 41 38 50Z",
    fill: "#6b4a2e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52C30 24 46 14 60 14S90 24 85 52L82 70C80 72 78 70 78 66L78 50C72 40 48 40 42 50L42 66C42 70 40 72 38 70Z",
    fill: "#7b5233"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20C52 17 68 17 74 20M42 30C50 25 70 25 78 30",
    stroke: "#5f3f27",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36C50 31 70 31 85 36",
    stroke: "#2c2620",
    strokeWidth: 5,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#b88a3a",
    strokeWidth: 2.4,
    fill: "#cfe3ea",
    fillOpacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 32,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 32,
    r: 7
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29Q48 27 51 28M67 29Q70 27 73 28",
    stroke: "#fff",
    strokeWidth: 1.6,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32H64",
    stroke: "#b88a3a",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "50%",
    cy: "48%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a1a08",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08",
    stopOpacity: 0.38
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#8a6a3a",
    opacity: 0.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait21);
export default __webpack_public_path__ + "static/media/player-portrait-21.8a33f2c028f16c83c8f757c33edfdf2c.svg";
export { ForwardRef as ReactComponent };